const productServices = [
  {
    value: '采购系统',
    key: 'CGXT',
    productList: [
      { name: '智能招投标', icon: 'icon-zhaotoubiao', color: '#1476ff', bgColor: '#F0F4FE', introduce: '为用户提供高效、准确、可靠的招投标流程和科学、实用的各种自动评标方案，帮助用户降低风险、节省时间和成本', key: 'znztb' },
      { name: '电子招投标', icon: 'icon-zhaobiao', color: '#9f53e6', bgColor: '#F0FBEF', introduce: '实现线上招投标流程的数字化和自动化，提高招投标效率和透明度，并降低相关成本和风险', key: 'dzztb' },
      { name: '单一品牌竞价', icon: 'icon-jingjia', color: '#f85835', bgColor: '#FCF9ED', introduce: '提供便捷、高效和透明的采购流程，降低采购成本并提升采购效益', key: 'dyppjj' },
      { name: '多品牌竞价', icon: 'icon-gengduo', color: '#1476ff', bgColor: '#F0F4FE', introduce: '促进多个品牌的竞价采购活动，实现降低采购成本、优化供应链和提升采购效益', key: 'dppjj' },
      { name: '邀请竞价', icon: 'icon-yaoqing1', color: '#25c251', bgColor: '#F0FBEF', introduce: '为用户提供一种精确和高效的供应商选择机制，从而降低采购成本、优化采购流程，并获得最有利的采购合同', key: 'yqjj' },
      { name: '招商竞价', icon: 'icon-zhaoshanghezuo', color: '#ffa500', bgColor: '#FFF4E5', introduce: '招商竞价功能是一种旨在吸引外部投资者、合作伙伴或商家加入特定项目、平台或业务领域的综合性工具和策略集合。其核心目标是通过一系列的手段和措施，促进资源的整合与共享，实现互利共赢的合作关系，推动项目或业务的快速发展和壮大。', key: 'zsjj' },
      { name: '网上议价', icon: 'icon-many-manage', color: '#9f53e6', bgColor: '#FFF5EB', introduce: '实现高效、透明和公正的议价采购过程，帮助企业降低采购成本、优化供应链，并获得最有利的采购合同', key: 'wsyjcg' },
      { name: '联合竞价', icon: 'icon-hetonglvyuejihua', color: '#9f53e6', bgColor: '#FFF5EB', introduce: '为采购用户提供一个集中管理、高效便捷的联合竞价采购平台，促进多个采购方联合进行竞价活动，实现降低采购成本、优化供应链和提升采购效益', key: 'lhjjcg' },
      { name: '试剂竞价', icon: 'icon-shiyanshiguanli', color: '#1476ff', bgColor: '#F0FBEF', introduce: '网上试剂竞价的目标是建立一个高效、透明、便捷的在线平台，用于管理试剂采购的竞价过程', key: 'sjjj' },
      { name: '耗材竞价', icon: 'icon-haocailingyong', color: '#25c251', bgColor: '#F0F4FE', introduce: '网上耗材竞价的目标是建立一个便捷、高效、透明的在线平台，用于管理耗材采购的竞价过程', key: 'hcjj' },
      { name: '药品竞价', icon: 'icon-yaopin', color: '#9f53e6', bgColor: '#FFF5EB', introduce: '网上药品竞价的目标是建立一个安全、高效、公正的在线平台，用于管理药品采购的竞价过程', key: 'ypjj' },
      { name: '工程类竞价', icon: 'icon-gongcheng', color: '#f85835', bgColor: '#FCF9ED', introduce: '网上工程类竞价的目标是建立一个高效、透明、公正的在线平台，用于管理工程项目的竞价过程', key: 'gcljj' },
      { name: '服务类竞价', icon: 'icon--fuwu', color: '#1476ff', bgColor: '#F0FBEF', introduce: '上服务类竞价的目标是建立一个便捷、高效、公正的在线平台，用于管理服务类项目的竞价过程', key: 'fwljj' },
      { name: '租息竞价', icon: 'icon-bucaozulin', color: '#25c251', bgColor: '#F0FBEF', introduce: '建立一个公平、透明、高效的在线平台，用于实现收租收息的竞价过程', key: 'zljj' },
      { name: '废旧物品处置', icon: 'icon-ziyuan3', color: '#1476ff', bgColor: '#F0F4FE', introduce: '建立一个高效、透明、可持续的在线平台，用于管理废旧物品的处置竞价过程', key: 'fjwzcz' },
      { name: '竞价商场', icon: 'icon-leimucushangchang', color: '#9f53e6', bgColor: '#FFF5EB', introduce: '实现供应商和买家之间的高效交易和竞争，促进市场的活跃和资源的优化分配', key: 'jjsc' },
      { name: '协议采购专场', icon: 'icon-xieyi', color: '#f85835', bgColor: '#F0FBEF', introduce: '提供一个专门用于协议采购的在线平台，实现高效便捷的采购流程，帮助企业降低采购成本、优化供应链和提升采购效益', key: 'xycgzc' },
      { name: '优惠采购专场', icon: 'icon-youhuiquan', color: '#25c251', bgColor: '#F0F4FE', introduce: '提供一个集中展示优惠采购商品和促销活动的在线平台，为特定用户提供便捷、实惠的购物体验，推动优惠采购市场的发展', key: 'yhcgzc' },
    ]
  },
  {
    value: '采购管理',
    key: 'CGGL',
    productList: [
      { name: '采购预算', icon: 'icon-yusuanguanli', color: '#f85835', bgColor: '#FCF9ED', introduce: '提供一种有效的资金规划和管理工具，确保采购活动与组织战略目标相一致', key: 'cgys' },
      { name: '采购计划', icon: 'icon-wj-jh', color: '#1476ff', bgColor: '#FFF5EB', introduce: '提供一种有效的采购计划制定和管理工具，确保采购活动与组织战略目标相一致', key: 'cgjh' },
      { name: '采购审批', icon: 'icon-fankuishenhe-weixuanzhong', color: '#25c251', bgColor: '#F0FBEF', introduce: '建立一个规范、高效的采购审批流程，确保采购活动符合组织政策和程序', key: 'cgsp' },
      { name: '采购需求管理', icon: 'icon-ziyuan2', color: '#9f53e6', bgColor: '#F0F4FE', introduce: '确定合适的设备选型，满足用户的采购需求', key: 'cgxqgl' },
      { name: '发货收验货管理', icon: 'icon-31daifahuo', color: '#f85835', bgColor: '#FCF9ED', introduce: '帮助企业实现发货和采购用户收验货的高效管理，减少物流环节中的错误和延误，优化供应链管理流程', key: 'fhsyhgl' },
      { name: '电子合同管理', icon: 'icon-hetonglvyuejihua', color: '#1476ff', bgColor: '#F0F4FE', introduce: '提供一个安全、高效的在线平台，帮助采购用户与供应商实现电子合同的创建、签署、管理和存储，简化合同管理过程，提高合同管理效率和准确性', key: 'dzhtgl' },
      { name: '验收管理', icon: 'icon-xiangmuyanshou_yanshou', color: '#25c251', bgColor: '#F0FBEF', introduce: '提供一个全面、高效的在线平台，用于跟踪和管理项目或产品的验收过程，确保项目或产品按照规定的标准和要求完成，并满足用户的需求和期望', key: 'ysgl' },
      { name: '试剂耗材仓储管理', icon: 'icon-cangchu', color: '#f85835', bgColor: '#FCF9ED', introduce: '帮助实验室或科研机构管理试剂和耗材的库存、入库、出库以及采购等相关流程，优化仓储管理，降低成本，提高效率和溯源能力', key: 'sjhcccgl' },
      { name: '集中支付管理', icon: 'icon-zhifubaofukuan', color: '#1476ff', bgColor: '#F0F4FE', introduce: '提供一个便捷、安全的在线平台，帮助采购用户实现对供应商采购费用通过第三方实施的集中支付和管理', key: 'jzzfgl' },
      { name: '评标专家管理', icon: 'icon-zhuanjia', color: '#f85835', bgColor: '#FCF9ED', introduce: '用于管理评标专家的信息、选拔、指派和绩效考核等过程', key: 'pbzjgl' },
      { name: '采购需求调查', icon: 'icon-caigoudingdanhuiqian', color: '#f85835', bgColor: '#FCF9ED', introduce: '帮助高校或组织全面、深入地了解市场上与采购相关的各类信息，从而为采购决策提供有力支持', key: 'cgxqdc' },
    ]
  }
]


const information_keys = {
  'cgys': {
    name: '采购预算',
      color: '#f85835',
      icon: 'icon-yusuanguanli',
      introduce: '提供有效的资金规划和管理工具，确保采购活动与组织战略目标相一致',
      // 目标和目的
      targets: [
      { value: '提供一种有效的资金规划和管理工具，确保采购活动与组织战略目标相一致' },
      { value: '合理分配采购资金，最大化采购效益，降低采购成本' },
      { value: '预测和控制采购支出，避免资金不足或超支情况的发生' },
      { value: '落实采购需求（采购内容，采购经费）' }
    ],
    // 核心功能
    cores: [
      { title: '项目申报', icon: 'icon-xiangmushenbao' },
      { title: '立项论证', icon: 'icon-tongzhidaibanicon' },
      { title: '预算批复', icon: 'icon-yinhangliushui' },
      { title: '增补预算', icon: 'icon-accountApplyComponentsCOD' },
      { title: '变更预算', icon: 'icon-biangeng' },
      { title: '项目考评', icon: 'icon-hrp_contract_management' },
    ],
      // 特色
      features: [
      { title: '规划确立预算', value: '以规划为前提确立预算方案。即规划确定目标，目标确立方案，方案落实预算', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '全过程管理', value: '实现从规划→预算→计划→执行→验收→评价全过程管理', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '涵盖项目广', value: '涵盖各种项目（经常性经费预算、外部专项性经费预算、内部专项性经费预算等）的预算管理', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
    ]
  },
  'cgxqgl': {
    name: '采购需求管理',
    color: '#9f53e6',
    icon: 'icon-ziyuan2',
    introduce: '确定合适的设备选型，满足用户的采购需求',
    // 目标和目的
    targets: [
      { value: '确定合适的设备选型，满足用户的采购需求' },
      { value: '确保采购决策的准确性和有效性' },
      { value: '提高采购效率，降低成本' }
    ],
    // 核心功能
    cores: [
      { title: '采购需求评估', value: '进行重要性、迫切性、合理性和可行性评估，确保与企业整体发展一致', icon: 'icon-fuwuji' },
      { title: '现有设备分析', value: '分析和评估现有同类设备的存量和利用率，包括设备数量、使用频率、寿命等，以及设备维护和维修成本', icon: 'icon-ProductIM' },
      { title: '设备选型', value: '进行市场调研，了解不同品牌和型号的设备性能、价格、售后服务等信息，根据技术参数和需求进行设备选型', icon: 'icon-qiyeshezhi' },
    ],
    // 特色
    features: [
      { title: '轻松快速上手', value: '提供直观简洁的用户界面，用户能够轻松上手并快速进行采购需求管理操作', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '自动采集分析', value: '自动采集和分析采购需求数据以及现有设备情况，提供准确的分析结论和建议', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '提供优化建议', value: '根据采购需求评估和设备分析结果，系统能够主动提供优化建议，帮助企业做出最佳的设备选型决策', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
    ]
  },
  'cgjh': {
    name: '采购计划',
    color: '#1476ff',
    icon: 'icon-wj-jh',
    introduce: '提供一种有效的采购计划制定和管理工具，确保采购活动与组织战略目标相一致',
    // 目标和目的
    targets: [
      { value: '提供一种有效的采购计划制定和管理工具，确保采购活动与组织战略目标相一致' },
      { value: '提高采购计划的准确性和可靠性，降低采购风险' },
      { value: '实现更高效的供应链管理，减少交付延误和资源浪费' },
      { value: '改善供应商管理，确保质量和可靠性' }
    ],
    // 核心功能
    cores: [
      { title: '采购需求分析和预测', icon: 'icon-xuqiufenxi' },
      { title: '供应商筛选与评估', icon: 'icon-pinggu' },
      { title: '采购计划编制', icon: 'icon-jindujihuabianzhi' },
      { title: '采购进度跟踪', icon: 'icon-jindu' },
      { title: '供应链协调和沟通', icon: 'icon-gongyinglianfuwu' },
    ],
    // 特色
    features: [
      { title: '轻松快速上手', value: '提供简洁、直观的用户界面，使用户能够轻松上手，并快速进行采购计划管理操作', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '分析跟踪数据', value: '通过数据统计和报表功能，对采购活动进行分析和跟踪，为企业决策提供依据', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '系统集成', value: '采购计划管理系统可与采购单位的资产管理、财务系统等进行集成，实现数据自动同步和流程协同', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '风险评估和监控', value: '提供风险评估和监控功能，帮助采购用户识别和应对采购过程中的风险，降低供应链风险', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '支持定制化', value: '支持定制化的采购审批流程，确保采购活动符合采购单位的授权和内部规范', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
    ]
  },
  'cgsp': {
    name: '采购审批',
    color: '#25c251',
    icon: 'icon-fankuishenhe-weixuanzhong',
    introduce: '建立一个规范、高效的采购审批流程，确保采购活动符合组织政策和程序',
    // 目标和目的
    targets: [
      { value: '建立一个规范、高效的采购审批流程，确保采购活动符合组织政策和程序' },
      { value: '加强对采购决策的控制和监督，降低采购风险和损失' },
      { value: '提高审批流程的效率，减少人工操作和时间成本' },
    ],
    // 核心功能
    cores: [
      { title: '采购申请', icon: 'icon-caigoushenqing' },
      { title: '审批流程设置', icon: 'icon-ico-presetuser-1OkF4cB' },
      { title: '审批过程跟踪', icon: 'icon-tijianlishi' },
      { title: '权限控制和安全性', icon: 'icon-quanxian' },
      { title: '审批意见和备注记录', icon: 'icon-a-danjucaozuoliuchengshenpiyijian' },
      { title: '数据分析和报告', icon: 'icon-shujufenxi' },
    ],
    // 特色
    features: [
      { title: '轻松快速上手', value: '具备直观简洁的用户界面，用户能够轻松进行审批操作和查看审批状态', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '分析跟踪数据', value: '具备灵活的配置和自定义功能，支持根据组织的需要设计和调整审批流程，以适应不同的用户需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '系统集成', value: '根据预设的审批规则和条件自动执行审批流程，减少人工干预和加快审批速度', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '风险评估和监控', value: '实时监控审批流程的进展情况，并对相关人员发送即时通知和提醒，确保审批流程按时进行', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '支持定制化', value: '提供手机端应用程序，方便审批人员随时随地进行审批操作，增强审批流程的灵活性和效率', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '支持定制化', value: '具备严格的数据安全措施和合规性保障，确保数据的机密性和完整性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'dyppjj': {
    name: '单一品牌竞价',
    color: '#f85835',
    icon: 'icon-jingjia',
    introduce: '提供便捷、高效和透明的采购流程，降低采购成本并提升采购效益',
    // 目标和目的
    targets: [
      { value: '提供便捷、高效和透明的采购流程，降低采购成本并提升采购效益' },
      { value: '简化采购流程、促进供应链的优化和管理、增加供应商的参与和竞争，并提供全面的数据支持和决策依据' }
    ],
    // 核心功能
    cores: [
      { title: '采购需求管理', value: '用户可以在线发布和管理采购需求，包括物品描述、数量、质量标准等，方便供应商了解采购需求', icon: 'icon-icon_111' },
      { title: '竞标管理', value: '供应商可以在线查看和参与采购项目，并提交竞价投标，通过竞价得到最有利的采购合同', icon: 'icon-jingbiaoliebiao' },
      { title: '自动化竞价', value: '系统根据预设的规则和权重对供应商的投标进行自动评估和排序，为采购方提供优选供应商的选择', icon: 'icon-xiaoshouzidonghua' },
      { title: '合同管理', value: '在竞价获胜后，系统支持在线合同签署和认证，简化采购合同的管理流程', icon: 'icon-hetongguanli' },
      { title: '供应商管理', value: '管理供应商档案，包括供应商资质、信用记录、评价等信息，方便采购方与供应商建立长期的合作关系', icon: 'icon-gongyingshangguanli-' },
    ],
    // 特色
    features: [
      { title: '网络化操作', value: '通过网络平台实现在线招标、投标和合同签署，提高采购流程的效率和便捷性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '高度透明', value: '系统提供全过程的信息共享和跟踪，确保采购过程的透明度，避免不公平行为的出现', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '多维度竞价', value: '系统支持多种竞价方式，例如价格竞价、质量竞价等，满足不同采购需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据安全和隐私保护', value: '采用高级加密技术，保障采购数据的安全和隐私', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '数据分析与决策支持', value: '通过数据分析和报告功能，提供对采购过程的全面分析和决策支持，帮助采购方做出合理的决策', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
    ]
  },
  'dppjj': {
    name: '多品牌竞价',
    color: '#1476ff',
    icon: 'icon-gengduo',
    introduce: '促进多个品牌的竞价采购活动，实现降低采购成本、优化供应链和提升采购效益',
    // 目标和目的
    targets: [
      { value: '促进多个品牌的竞价采购活动，实现降低采购成本、优化供应链和提升采购效益' },
      { value: '提高采购效率、增加供应商竞争、提供数据支持和决策依据' },
      { value: '也可用于指定三个品牌以上货物的简易快速招投标，在保证公开、公平、公正的原则下，更能体现用户需求和主体性' }
    ],
    // 核心功能
    cores: [
      { title: '招标发布和管理', value: '用户可以在线发布多个品牌的招标信息，并通过系统进行集中管理和跟踪，方便供应商参与竞价', icon: 'icon-zhaobiaopaimai' },
      { title: '投标管理', value: '供应商可以在线查看和参与各个品牌的竞价活动，并提交相应的投标文件进行竞价', icon: 'icon-zhaotoubiao' },
      { title: '自动化竞价', value: '系统根据设定的评标标准和权重，自动对投标文件进行评估和排序，为采购方提供选择优选供应商的依据', icon: 'icon-xiaoshouzidonghua' },
      { title: '数据分析与报告', value: '系统收集和分析多品牌采购过程中的数据，生成统计报告和趋势分析，为决策提供数据支持', icon: 'icon-shujufenxi1' },
      { title: '合同管理', value: '系统支持在线合同签署和认证，简化多品牌采购过程中的合同管理流程', icon: 'icon-hetongguanli' },
    ],
    // 特色
    features: [
      { title: '多品牌管理', value: '支持同时管理多个品牌的竞价采购活动，方便采购用户集中管理和优化采购流程', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '网络化操作', value: '通过网络平台实现在线招标、投标和合同签署，提高采购流程的效率和便捷性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '高度透明', value: '系统提供全过程的信息共享和跟踪，确保竞价采购过程的透明度和公正性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '多维度竞价', value: '系统支持多种竞价方式，例如价格竞价、质量竞价等，满足不同品牌采购的需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '数据安全和隐私保护', value: '采用高级加密技术，保障采购数据的安全和隐私', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '数据分析与决策支持', value: '通过数据分析和引入市场均价、当量价概念，提供对多品牌采购过程的全面分析和决策支持，结果更为合理', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'yqjj': {
    name: '邀请竞价',
    color: '#25c251',
    icon: 'icon-yaoqing1',
    introduce: '为用户提供一种精确和高效的供应商选择机制，从而降低采购成本、优化采购流程，并获得最有利的采购合同',
    // 目标和目的
    targets: [
      { value: '为用户提供一种精确和高效的供应商选择机制，从而降低采购成本、优化采购流程，并获得最有利的采购合同' },
      { value: '节约时间和资源、增加供应商竞争度、提高采购效率和效益' },
    ],
    // 核心功能
    cores: [
      { title: '供应商邀请', value: '系统支持采购方根据采购需求和要求邀请特定的供应商参与竞价活动', icon: 'icon-yaoqing' },
      { title: '竞价设置', value: '设置并管理竞价规则、商务条款、竞价时间以及评估标准等，确保竞价过程的公正性和透明度', icon: 'icon-shezhi' },
      { title: '投标管理', value: '供应商可以在线提交竞价文件，包括报价、产品规格、交货期等，参与竞价活动', icon: 'icon-zhaotoubiao' },
      { title: '自动化竞价', value: '系统自动对供应商提交的竞价文件进行评估和排序，提供客观、准确的竞标结果', icon: 'icon-xiaoshouzidonghua' },
      { title: '数据分析与报告', value: '系统收集和分析竞价过程中的数据，生成统计报告和趋势分析，为决策提供数据支持', icon: 'icon-shujufenxi1' },
      { title: '合同管理', value: '在竞价获胜后，系统支持在线合同签署和认证，简化合同管理流程', icon: 'icon-hetongguanli' },
    ],
    // 特色
    features: [
      { title: '精准邀请', value: '采购方可以根据具体需求和要求，有针对性地邀请特定的供应商参与竞价，提高供应商的竞争度', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '高效竞价', value: '系统提供自动化的竞价评估功能，快速完成竞价活动，并生成客观、准确的竞标结果', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '数据分析与报告', value: '通过数据分析和报告功能，提供对竞价过程和结果的多维度分析和洞察，为决策提供支持', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据安全与隐私保护', value: '采用高级加密技术，保障竞价和采购数据的安全和隐私', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '网络化操作与便捷性', value: '通过网络平台实现在线邀请、投标和合同签署，提高竞价采购流程的效率和便捷性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '可定制化和扩展性', value: '根据用户需求，提供定制开发和功能扩展的灵活性，满足不同采购场景的需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'wsyjcg': {
    name: '网上议价',
    color: '#9f53e6',
    icon: 'icon-many-manage',
    introduce: '实现高效、透明和公正的议价采购过程，帮助企业降低采购成本、优化供应链，并获得最有利的采购合同',
    // 目标和目的
    targets: [
      { value: '实现高效、透明和公正的议价采购过程，帮助企业降低采购成本、优化供应链，并获得最有利的采购合同' },
      { value: '简化议价流程、增加供应商的竞争度、提高采购效率和效益' },
    ],
    // 核心功能
    cores: [
      { title: '采购需求管理', value: '用户可以在线发布和管理采购需求，包括物品描述、数量、规格等信息，方便供应商了解采购需求', icon: 'icon-icon_111' },
      { title: '邀请供应商', value: '采购方可以邀请特定的供应商参与议价活动，并设定议价开始时间和结束时间', icon: 'icon-yaoqing' },
      { title: '供应商参与', value: '供应商收到邀请后，可以登录系统进行在线议价，提交价格和报价说明等信息', icon: 'icon-canyujingjia' },
      { title: '实时议价', value: '系统支持供应商和采购方实时互动，进行价格协商和调整，以达成最终的议价结果', icon: 'icon-shishi' },
      { title: '数据分析与报告', value: '系统收集和分析议价过程中的数据，生成统计报告和趋势分析，为决策提供数据支持', icon: 'icon-shujufenxi1' },
      { title: '合同管理', value: '议价达成后，系统支持在线合同签署和认证，简化采购合同的管理流程', icon: 'icon-hetongguanli' },
    ],
    // 特色
    features: [
      { title: '高效议价', value: '通过在线平台实现供应商和采购方的实时互动，加快议价进程，提高议价效率', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '透明公正', value: '系统提供全过程的信息共享和跟踪，确保议价过程的透明度和公正性，避免不公平行为', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '数据分析与报告', value: '通过数据分析和报告功能，提供对议价过程和结果的多维度分析和洞察，为决策提供支持', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据安全与隐私保护', value: '采用高级加密技术，保障议价和采购数据的安全和隐私', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '灵活配置和扩展性', value: '根据用户需求，提供配置和定制开发的灵活性，适应不同议价场景的需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '网络化操作与便捷性', value: '通过网络平台实现在线议价活动，方便供应商和采购方的参与和操作', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'lhjjcg': {
    name: '联合竞价',
    color: '#9f53e6',
    icon: 'icon-hetonglvyuejihua',
    introduce: '为采购用户提供一个集中管理、高效便捷的联合竞价采购平台，增加供应商竞争度、降低采购成本及采购风险',
    // 目标和目的
    targets: [
      { value: '为采购用户提供一个集中管理、高效便捷的联合竞价采购平台，增加供应商竞争度、降低采购成本及采购风险' },
      { value: '增加供应商竞争度、提高采购效率、降低采购成本及采购风险' },
    ],
    // 核心功能
    cores: [
      { title: '采购需求管理', value: '联合竞价采购平台支持多个采购方发布和管理采购需求，包括物品描述、数量、规格等信息', icon: 'icon-icon_111' },
      { title: '联合竞价设置', value: '系统支持联合竞价规则的设定，包括起拍价、最低价、竞价时间等参数的设定，并确保竞价过程的公正性和透明度', icon: 'icon-shezhi' },
      { title: '供应商参与', value: '供应商可以在线参与多个采购方的联合竞价活动，并提交竞价文件进行竞价', icon: 'icon-canyujingjia' },
      { title: '自动化竞价', value: '系统自动对供应商提交的竞价文件进行评估和排序，提供客观、准确的竞标结果', icon: 'icon-xiaoshouzidonghua' },
      { title: '数据分析与报告', value: '系统收集和分析联合竞价过程中的数据，生成统计报告和趋势分析，为决策提供数据支持', icon: 'icon-shujufenxi1' },
      { title: '合同管理', value: '在竞价达成后，系统支持在线合同签署和认证，简化采购合同的管理流程', icon: 'icon-hetongguanli' },
    ],
    // 特色
    features: [
      { title: '多采购方联合竞价', value: '支持多个采购方联合进行竞价活动，提高供应商的竞争度，降低采购成本', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '网络化操作和便捷性', value: '通过网络平台实现在线联合竞价活动，提高竞价采购流程的效率和便捷性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '高度透明和公正', value: '系统提供全过程的信息共享和跟踪，确保联合竞价过程的透明度和公正性，避免不公平行为', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据分析与决策支持', value: '通过数据分析和报告功能，提供对联合竞价过程的全面分析和决策支持，帮助采购方做出合理的决策', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '数据安全和隐私保护', value: '采用高级加密技术，保障竞价和采购数据的安全和隐私', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '灵活配置和扩展性', value: '根据用户需求，提供灵活的配置和可定制化开发，满足不同联合竞价场景的需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'zljj': {
    name: '收租收息',
    color: '#25c251',
    icon: 'icon-bucaozulin',
    introduce: '适用于场地、门面、服务等出租以收取租金，以及大额资金定期存放以获取利息等',
    // 目标和目的
    targets: [
      { value: '适用于场地、门面、服务等出租以收取租金，以及大额资金定期存放以获取利息等' },
      { value: '促进租息竞价市场的活跃和竞争，确保公共资源的合理利用，提供用户更多的选择和经济效益' },
    ],
    // 核心功能
    cores: [
      { title: '公物信息发布', value: '提供在线发布收租收息信息，包括名称、规格、使用条件等，吸引收租收息方的关注', icon: 'icon-fabu' },
      { title: '竞价发布和管理', value: '支持收租收息方在线发布竞价信息，包括希望收租收息的公物、租期和竞价开始结束时间等',icon: 'icon-jia' },
      { title: '报价和出价管理', value: '允许收租收息方和出租方进行在线报价和出价，系统记录并实时展示竞价状态和排名',icon: 'icon-tubiao-baojia' },
      { title: '收租收息合同管理', value: '支持在线生成收租收息合同，并记录双方的收租收息协议和相关约定',icon: 'icon--fangzuxi' },
      { title: '竞价结果与支付', value: '在竞价结束后，公布竞价结果，确定中标收租收息方，并提供支付功能，方便双方完成收租收息交易',icon: 'icon-zhifubao' },
      { title: '用户评价和信誉体系', value: '允许用户对完成收租收息的公物和服务提供评价，并建立信誉体系，促进收租收息市场的信任建设',icon: 'icon-chengxinfuwu' },
    ],
    // 特色
    features: [
      { title: '公平公正的竞价环境', value: '通过建立公平竞价规则和透明展示系统，确保竞租过程公正公开，避免利益不均', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '多种竞价模式', value: '支持不同竞价模式，如最高价胜出、最低价胜出或综合评分胜出等，灵活满足收租收息方需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '实时竞价展示', value: '提供实时展示竞价状态和排名，使收租收息方和出租方能够及时了解竞争情况和调整策略', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据分析和洞察', value: '通过数据分析和报告功能，提供对竞租历史数据的分析和洞察，为决策提供参考', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '用户评价和信誉体系', value: '允许用户对公物和服务进行评价，建立信誉体系，提高收租收息市场的信任度和合作效果', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '数据安全与隐私保护', value: '采用安全加密技术和权限控制机制，确保用户信息和收租收息数据的安全和隐私保护', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'znztb': {
    name: '智能招投标',
    color: '#1476ff',
    icon: 'icon-zhaotoubiao',
    introduce: '为用户提供高效、准确、可靠的招投标流程和科学、实用的各种自动评标方案，帮助用户降低风险、节省时间和成本',
    // 目标和目的
    targets: [
      { value: '为用户提供高效、准确、可靠的招投标流程和科学、实用的各种自动评标方案，帮助用户降低风险、节省时间和成本' },
      { value: '简化招投标流程、提高招标效率和透明度' },
      { value: '加强数据分析和决策支持，以实现优秀的招投标管理和结果' },
    ],
    // 核心功能
    cores: [
      { title: '招标管理', value: '用户可以快速发布招标公告和相关文件，指定招标条件、要求和截止日期等信息', icon: 'icon-zhaobiaopaimai' },
      { title: '投标管理', value: '系统集中管理所有投标文件，提供用户友好的界面和工具，实现投标文件的上传、审核和评估', icon: 'icon-zhaotoubiao' },
      { title: '自动评标', value: '根据设定的评标标准和权重，系统自动对投标文件进行评分和排序，提供客观、准确和公正的评标结果', icon: 'icon-pinggu1' },
      { title: '电子签名', value: '支持电子签名功能，用户可以在线完成合同的签署和认证，提高合同签订的效率和安全性', icon: 'icon-dianziqianmingshezhi' },
      { title: '数据分析和报告', value: '收集和分析招投标过程中的数据，生成统计报告和趋势分析，为用户提供决策支持', icon: 'icon-shujufenxi1' },
      { title: '风险管理', value: '识别和管理招投标过程中的潜在风险，提供风险预警和防范措施，保护用户利益', icon: 'icon-fengxianguanli' },
    ],
    // 特色
    features: [
      { title: '自动化及智能化', value: '应用人工智能和大数据技术，实现自动化和智能化的招投标流程管理', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '轻松快速上手', value: '提供直观简洁的用户界面，使用户能够轻松上手并快速进行招投标操作', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '安全性和隐私保护', value: '采用严格的数据加密和访问控制措施，保证用户数据的安全性和隐私保护', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '功能多样化', value: '通过自动化评标、电子签名等功能，提高招标效率和评标准确性、合理性、公正性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '提供定制开发', value: '提供多种自动评标方案，满足不同用户的需求，提供定制开发和功能扩展的灵活性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
    ]
  },
  'dzztb': {
    name: '电子招投标',
    color: '#9f53e6',
    icon: 'icon-zhaobiao',
    introduce: '实现线上招投标流程的数字化和自动化，提高招投标效率和透明度，并降低相关成本和风险',
    // 目标和目的
    targets: [
      { value: '实现线上招投标流程的数字化和自动化，提高招投标效率和透明度，并降低相关成本和风险' },
      { value: '简化招投标流程、提升数据管理的准确性和安全性、促进公平竞争和资源优化' },
    ],
    // 核心功能
    cores: [
      { title: '招标发布和管理', value: '用户可以在线发布招标公告、招标文件和相关信息，并对招标项目进行集中管理，包括截止日期、资格要求、技术规范等', icon: 'icon-zhaobiaopaimai' },
      { title: '投标管理', value: '承包商可以在线查看和下载招标文件，提交投标文件，进行投标保证金缴纳，并获得投标结果通知', icon: 'icon-zhaotoubiao' },
      { title: '自动化开评标管理', value: '系统根据事先设定的开评标流程，并依评标专家的分项评分结果自动计算出总评分及排名结果，提供客观、准确和公正的评标决策', icon: 'icon-pinggu1' },
      { title: '电子签名和合同管理', value: '支持电子签名技术，实现在线合同签署和认证，有效管理招投标过程中的合同文件', icon: 'icon-dianziqianmingshezhi' },
      { title: '数据分析和报告', value: '通过收集、整理和分析招投标过程中的数据，生成统计报告和趋势分析，为决策提供支持', icon: 'icon-shujufenxi1' },
      { title: '风险管理和监控', value: '识别和管理招投标过程中的潜在风险，并提供风险预警和监控功能，确保安全和合规', icon: 'icon-fengxianguanli' },
    ],
    // 特色
    features: [
      { title: '数字化流程管理', value: '实现线上招投标全流程的数字化管理，提升操作效率和信息共享的便利性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '数据准确性和安全性', value: '采用高级加密技术，确保招投标数据的准确性和安全性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '可定制化和扩展性', value: '根据用户需求，提供定制开发和功能扩展的灵活性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
      { title: '功能较齐全', height: '300px', value: '招标范围广泛，涵盖货物、工程、服务等方面的招投标；招标门类齐全，涵盖公开招标、邀请招标、单一来源、竞争性磋商、竞争性谈判、询价；评标方法多样，综合评分法（偏离）、综合计分法、层次分析法、综合最低评标价法、最低评标价法等；评标方式灵活，含人工评标、智能评标、当地评标、异地评标等', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '引入市场均价、当量价等概念', height: '300px', value: '完善了投标价的比较和评价机制，解决了不同品牌、型号标的物之间投标价的一致性、可比性的问题，对于确保采购品质和成本控制具有重要意义，既保证了评标过程的严肃性，又保证了评标结果的合理性，使评标更具规范和科学。', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '数据挖掘、智能分析', height: '300px', value: '采用了大数据、数据挖掘、智能分析处理等先进技术手段，更好地挖掘市场资源，科学计算分析评标结果，提供更精准、高效的数据支持，加强了采购决策的科学性和准确性，为采购部门提供较为客观、公正、科学、合理的评判和选择依据', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
    ]
  },
  'sjjj': {
    name: '试剂竞价',
    color: '#1476ff',
    icon: 'icon-shiyanshiguanli',
    introduce: '网上试剂竞价的目标是建立一个高效、透明、便捷的在线平台，用于管理试剂采购的竞价过程',
    // 目标和目的
    targets: [
      { value: '网上试剂竞价的目标是建立一个高效、透明、便捷的在线平台，用于管理试剂采购的竞价过程' },
      { value: '其主要目的是为试剂采购方提供更多的供应商选择和优质产品，同时为试剂供应商提供更多商机和经济效益' },
    ],
    // 核心功能
    cores: [
      { title: '试剂需求发布', value: '提供在线发布试剂采购需求信息，包括试剂类型、规格、数量、质量要求等，吸引供应商的关注', icon: 'icon-fabu' },
      { title: '竞价发布和管理', value: '支持采购方在线发布竞价信息，包括采购要求、报价要求和竞价开始结束时间等', icon: 'icon-jia' },
      { title: '报价和出价管理', value: '允许供应商进行在线报价和出价，系统记录并实时展示竞价状态和排名，与采购方进行交流', icon: 'icon-tubiao-baojia' },
      { title: '合同管理', value: '支持在线生成采购合同，并记录双方的协议和相关约定', icon: 'icon-hetongguanli' },
      { title: '竞价结果与支付', value: '在竞价结束后，公布竞价结果，确定中标供应商，并提供支付功能，方便双方完成采购交易', icon: 'icon-zhifubao' },
      { title: '数据分析和洞察', value: '通过数据分析和报告功能，提供对竞价历史数据的分析和洞察，为决策提供参考', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '多样化的试剂选择', value: '通过平台上多家供应商的竞争，提供更多的试剂选择，帮助采购方找到符合需求的优质产品', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '公平公正的竞价环境', value: '确保竞价过程公平公正，避免不正当竞争行为', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '实时竞价展示', value: '提供实时展示竞价状态和排名，使采购方能够及时了解竞争情况和调整采购策略', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据安全与隐私保护', value: '采用安全加密技术和权限控制机制，确保用户信息和竞价数据的安全和隐私保护', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '供应商评价和信誉体系', value: '允许用户对供应商和产品进行评价，建立信誉体系，提高竞价平台的信任度和合作效果', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '成本控制和经济效益', value: '通过竞价机制，帮助采购方获得更有竞争力的价格，提高成本控制和经济效益', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'hcjj': {
    name: '耗材竞价',
    color: '#25c251',
    icon: 'icon-haocailingyong',
    introduce: '网上耗材竞价的目标是建立一个便捷、高效、透明的在线平台，用于管理耗材采购的竞价过程',
    // 目标和目的
    targets: [
      { value: '网上耗材竞价的目标是建立一个便捷、高效、透明的在线平台，用于管理耗材采购的竞价过程' },
      { value: '其主要目的是为耗材采购方提供更多供应商选择和优质产品，同时帮助供应商获得更多商机和经济效益' },
    ],
    // 核心功能
    cores: [
      { title: '耗材需求发布', value: '提供在线发布耗材采购需求信息，包括耗材类型、规格、数量、质量要求等，吸引供应商的关注', icon: 'icon-fabu' },
      { title: '竞价发布和管理', value: '支持采购方在线发布竞价信息，包括采购要求、报价要求和竞价开始结束时间等',icon: 'icon-jia' },
      { title: '报价和出价管理', value: '允许供应商进行在线报价和出价，系统记录并实时展示竞价状态和排名，与采购方进行交流', icon: 'icon-tubiao-baojia' },
      { title: '合同管理', value: '支持在线生成采购合同，并记录双方的协议和相关约定', icon: 'icon-hetongguanli' },
      { title: '竞价结果与支付', value: '在竞价结束后，公布竞价结果，确定中标供应商，并提供支付功能，方便双方完成采购交易', icon: 'icon-zhifubao' },
      { title: '数据分析和洞察', value: '通过数据分析和报告功能，提供对竞价历史数据的分析和洞察，为决策提供参考', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '多样化的耗材选择', value: '通过平台上多家供应商的竞争，提供更多的耗材选择，满足不同领域和需求的采购方需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '公平公正的竞价环境', value: '确保竞价过程公平公正，避免产生不正当竞争行为', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '实时竞价展示', value: '提供实时展示竞价状态和排名，使采购方能够及时了解竞争情况和调整采购策略', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据安全与隐私保护', value: '采用安全加密技术和权限控制机制，确保用户信息和竞价数据的安全和隐私保护', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '供应商评价和信誉体系', value: '允许用户对供应商和耗材进行评价，建立信誉体系，提高竞价平台的信任度和合作效果', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '成本控制和经济效益', value: '通过竞价机制，帮助采购方获得更有竞争力的价格，提高成本控制和经济效益', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'ypjj': {
    name: '药品竞价',
    color: '#9f53e6',
    icon: 'icon-yaopin',
    introduce: '网上药品竞价的目标是建立一个安全、高效、公正的在线平台，用于管理药品采购的竞价过程',
    // 目标和目的
    targets: [
      { value: '网上药品竞价的目标是建立一个安全、高效、公正的在线平台，用于管理药品采购的竞价过程' },
      { value: '其主要目的是为药品采购方提供更多的供应商选择和优质药品，同时帮助供应商获取更多商机和经济效益' },
    ],
    // 核心功能
    cores: [
      { title: '药品需求发布', value: '提供在线发布药品采购需求信息，包括药品名称、规格、数量、质量要求等，吸引供应商的关注', icon: 'icon-fabu' },
      { title: '竞价发布和管理', value: '支持采购方在线发布竞价信息，包括采购要求、报价要求和竞价开始结束时间等',icon: 'icon-jia' },
      { title: '报价和出价管理', value: '允许供应商进行在线报价和出价，系统记录并实时展示竞价状态和排名，与采购方进行交流',icon: 'icon-tubiao-baojia' },
      { title: '合同管理', value: '支持在线生成采购合同，并记录双方的协议和相关约定', icon: 'icon-hetongguanli' },
      { title: '竞价结果与支付', value: '在竞价结束后，公布竞价结果，确定中标供应商，并提供支付功能，方便双方完成采购交易', icon: 'icon-zhifubao' },
      { title: '数据分析和洞察', value: '通过数据分析和报告功能，提供对竞价历史数据的分析和洞察，为决策提供参考', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '多样化的药品选择', value: '通过平台上多家供应商的竞争，提供更多的药品选择，确保采购方能获取到符合需求的优质药品', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '公平公正的竞价环境', value: '确保竞价过程公平公正，防止不正当竞争行为', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '实时竞价展示', value: '提供实时展示竞价状态和排名，使采购方能够及时了解竞争情况并调整采购策略', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据安全与隐私保护', value: '采用安全加密技术和权限控制机制，保证用户信息和竞价数据的安全和隐私保护', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '供应商评价和信誉体系', value: '允许用户对供应商和药品进行评价，建立信誉体系，提高竞价平台的信任度和合作效果', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '成本控制和经济效益', value: '通过竞价机制，帮助采购方获得更具竞争力的价格，提升成本控制和经济效益', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'gcljj': {
    name: '工程类竞价',
    color: '#f85835',
    icon: 'icon-gongcheng',
    introduce: '网上工程类竞价的目标是建立一个高效、透明、公正的在线平台，用于管理工程项目的竞价过程',
    // 目标和目的
    targets: [
      { value: '网上工程类竞价的目标是建立一个高效、透明、公正的在线平台，用于管理工程项目的竞价过程' },
      { value: '促进工程项目的竞争性定价，提供客观公正的选择机制，为工程项目的委托方和承包方提供更多商机和经济效益' },
    ],
    // 核心功能
    cores: [
      { title: '工程信息发布', value: '提供在线发布工程项目信息，包括项目类型、规模、地点、计划等，吸引承包方的关注', icon: 'icon-fabu' },
      { title: '竞价发布和管理', value: '支持委托方在线发布竞价信息，包括工程要求、报价要求和竞价开始结束时间等',icon: 'icon-jia' },
      { title: '报价和出价管理', value: '允许承包方进行在线报价和出价，系统记录并实时展示竞价状态和排名，与委托方进行交流',icon: 'icon-tubiao-baojia' },
      { title: '合同管理', value: '支持在线生成工程合同，并记录双方的协议和相关约定', icon: 'icon-hetongguanli' },
      { title: '竞价结果与支付', value: '在竞价结束后，公布竞价结果，确定中标承包方，并提供支付功能，方便双方完成项目合作交易', icon: 'icon-zhifubao' },
      { title: '数据分析和洞察', value: '通过数据分析和报告功能，提供对竞价历史数据的分析和洞察，为决策提供参考', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '公平公正的竞价环境', value: '通过建立公平竞价规则和透明展示系统，确保竞价过程公正公开，避免利益不均', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '多种竞价方式', value: '支持不同的竞价方式，如最低价胜出、综合评分胜出或技术评审胜出等，灵活满足委托方需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '实时竞价展示', value: '提供实时展示竞价状态和排名，使委托方和承包方能够及时了解竞争情况和调整策略', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据安全与隐私保护', value: '采用安全加密技术和权限控制机制，确保用户信息和竞价数据的安全与隐私保护', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '用户评价和信誉体系', value: '允许用户对工程项目和服务进行评价，建立信誉体系，提高竞价平台的信任度和合作效果', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '智能推荐和匹配', value: '通过智能算法和数据分析，为委托方和承包方提供项目推荐和合作匹配，提高双方的匹配度和效率', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'fwljj': {
    name: '服务类竞价',
    color: '#1476ff',
    icon: 'icon--fuwu',
    introduce: '上服务类竞价的目标是建立一个便捷、高效、公正的在线平台，用于管理服务类项目的竞价过程',
    // 目标和目的
    targets: [
      { value: '上服务类竞价的目标是建立一个便捷、高效、公正的在线平台，用于管理服务类项目的竞价过程' },
      { value: '促进服务供应商的竞争性定价，提供广泛的选择和经济效益，同时为服务需求方提供更好的服务质量和成本控制' },
    ],
    // 核心功能
    cores: [
      { title: '服务需求发布', value: '提供在线发布服务需求信息，包括服务类型、规格、地点、时间等，吸引服务供应商的关注', icon: 'icon-fabu' },
      { title: '竞价发布和管理', value: '支持需求方在线发布竞价信息，包括服务要求、报价要求和竞价开始结束时间等',icon: 'icon-jia' },
      { title: '报价和出价管理', value: '允许供应商进行在线报价和出价，系统记录并实时展示竞价状态和排名，与需求方进行交流',icon: 'icon-tubiao-baojia' },
      { title: '合同管理', value: '支持在线生成服务合同，并记录双方的协议和相关约定', icon: 'icon-hetongguanli' },
      { title: '竞价结果与支付', value: '在竞价结束后，公布竞价结果，确定中标供应商，并提供支付功能，方便双方完成服务合作交易', icon: 'icon-zhifubao' },
      { title: '数据分析和洞察', value: '通过数据分析和报告功能，提供对竞价历史数据的分析和洞察，为决策提供参考', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '公平公正的竞价环境', value: '通过建立公平竞价规则和透明展示系统，确保竞价过程公正公开，减少不正当竞争行为', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '多种竞价方式', value: '支持不同的竞价方式，如最低价胜出、综合评分胜出或技术评审胜出等，以满足需求方的不同需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '实时竞价展示', value: '提供实时展示竞价状态和排名，使需求方和供应商能够及时了解竞争情况和调整策略', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '智能推荐和匹配', value: '通过智能算法和数据分析，为需求方和供应商提供服务推荐和合作匹配，提高双方的匹配度和效率', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '数据安全与隐私保护', value: '采用安全加密技术和权限控制机制，确保用户信息和竞价数据的安全与隐私保护', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '用户评价和信誉体系', value: '允许用户对服务和供应商进行评价，建立信誉体系，提高竞价平台的信任度和合作效果', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'fjwzcz': {
    name: '废旧物品处置',
    color: '#1476ff',
    icon: 'icon-ziyuan3',
    introduce: '建立一个高效、透明、可持续的在线平台，用于管理废旧物品的处置竞价过程',
    // 目标和目的
    targets: [
      { value: '建立一个高效、透明、可持续的在线平台，用于管理废旧物品的处置竞价过程' },
      { value: '促进废旧物品的合理处理和再利用，减少环境污染，推动资源循环利用，提供用户更多的商机和经济效益' },
    ],
    // 核心功能
    cores: [
      { title: '废旧物品信息发布', value: '提供在线发布废旧物品处置信息，包括物资类型、数量、质量、处置要求等，吸引处置方的关注', icon: 'icon-fabu' },
      { title: '竞价发布和管理', value: '支持处置方在线发布竞价信息，包括处理方式、报价要求和竞价开始结束时间等',icon: 'icon-jia' },
      { title: '报价和出价管理', value: '允许处置方和供应商进行在线报价和出价，系统记录并实时展示竞价状态和排名',icon: 'icon-tubiao-baojia' },
      { title: '处置合同管理', value: '支持在线生成处置合同，并记录双方的处置协议和相关约定', icon: 'icon-hetongguanli' },
      { title: '竞价结果与支付', value: '在竞价结束后，公布竞价结果，确定中标供应商，并提供支付功能，方便双方完成废旧物品处置交易', icon: 'icon-zhifubao' },
      { title: '数据分析和洞察', value: '通过数据分析和报告功能，提供对竞价历史数据的分析和洞察，为决策提供参考', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '环保可持续的处置流程', value: '通过建立环保处置标准和可持续处理方式，确保废旧物品得到合理处理和再利用', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '多种竞价方式', value: '支持不同的竞价方式，如最高价胜出、最低价胜出或综合评分胜出等，灵活满足处置方需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '实时竞价展示', value: '提供实时展示竞价状态和排名，使处置方和供应商能够及时了解竞争情况和调整策略', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据安全与隐私保护', value: '采用安全加密技术和权限控制机制，确保用户信息和处置数据的安全和隐私保护', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '用户评价和信誉体系', value: '允许用户对废旧物品处置过程进行评价，建立信誉体系，提高参与者的信任度和合作效果', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '促进资源循环利用', value: '通过在线竞价平台，提供更多商机和经济效益，促进废旧物品的再利用和资源循环利用', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'jjsc': {
    name: '竞价商场',
    color: '#9f53e6',
    icon: 'icon-leimucushangchang',
    introduce: '实现供应商和买家之间的高效交易和竞争，促进市场的活跃和资源的优化分配',
    // 目标和目的
    targets: [
      { value: '实现供应商和买家之间的高效交易和竞争，促进市场的活跃和资源的优化分配' },
      { value: '降低采购成本、拓展销售渠道、提升交易效率和创造更好的商业机会' },
    ],
    // 核心功能
    cores: [
      { title: '注册和认证', value: '供应商和买家可以在线注册并进行身份认证，建立可信任的商业交易关系',icon: 'icon-renzheng' },
      { title: '产品发布和搜索', value: '供应商可以发布产品信息，买家可以通过关键词搜索和筛选产品，提供方便的交易对接',icon: 'icon-sousuo' },
      { title: '竞价和议价', value: '买家可以发起竞价或议价活动，吸引供应商参与，并获得最有利的交易价格',icon: 'icon-ico_yishenggongzuozhan_yijiashenhe' },
      { title: '订单管理', value: '买家可以在线下单和管理订单，供应商可以接受订单并进行供货和发货操作',icon: 'icon-dingdan' },
      { title: '评价和反馈', value: '买家可以对供应商进行评价和反馈，帮助其他买家做出选择；供应商也可以对买家的付款和配合进行评价',icon: 'icon-pingjia' },
      { title: '数据分析与报告', value: '系统收集和分析交易数据，生成统计报告和趋势分析，为用户提供市场洞察和决策支持', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '多样化的商品', value: '网上竞价商场提供丰富多样的商品和服务，满足用户各种需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '高效的交易过程', value: '通过在线平台实现供应商和买家之间的高效交易和沟通，简化交易流程，提高交易效率', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '竞价和议价功能', value: '买家可以发起竞价或议价活动，吸引供应商参与并获得最佳价格', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据分析与报告', value: '通过数据分析和报告功能，提供对市场趋势和交易数据的全面分析，为用户提供决策支持', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '信任和安全', value: '通过身份认证和评价系统，建立可信任的商业交易环境，保障用户的权益和数据安全', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '拓展销售渠道', value: '为供应商提供一个开放的销售渠道，扩大业务范围，寻求更多商业机会', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'xycgzc': {
    name: '协议采购专场',
    color: '#f85835',
    icon: 'icon-xieyi',
    introduce: '提供一个专门用于协议采购的在线平台，实现高效便捷的采购流程，帮助企业降低采购成本、优化供应链和提升采购效益',
    // 目标和目的
    targets: [
      { value: '提供一个专门用于协议采购的在线平台，实现高效便捷的采购流程，帮助企业降低采购成本、优化供应链和提升采购效益' },
      { value: '简化协议采购流程、降低采购风险、增加供应商竞争度' },
    ],
    // 核心功能
    cores: [
      { title: '协议发布与管理', value: '采购方可以在线发布和管理协议采购需求，包括物品描述、数量、规格等信息，并设定协议有效期限', icon: 'icon-fabu' },
      { title: '供应商邀请', value: '采购方可以邀请符合需求的供应商参与协议竞标，提高供应商的参与度和竞争度', icon: 'icon-yaoqing' },
      { title: '竞价和议价', value: '供应商可以在线进行竞价或议价，提交报价和议价要求等信息', icon: 'icon-ico_yishenggongzuozhan_yijiashenhe' },
      { title: '自动化评估', value: '系统能够自动对供应商提交的竞价和议价进行评估和排序，提供客观、准确的分析结果', icon: 'icon-xiaoshouzidonghua' },
      { title: '定量分析及决策支持', value: '系统支持收集和分析协议采购过程中的数据，生成统计报告和趋势分析，为决策提供数据支持', icon: 'icon-shujufenxi1' },
      { title: '合同管理', value: '在竞价或议价达成后，系统支持在线合同签订和认证，简化采购合同管理流程', icon: 'icon-hetongguanli' },
    ],
    // 特色
    features: [
      { title: '简化协议采购流程', value: '通过在线平台实现采购方与供应商之间的高效互动和交流，简化协议采购流程，提高采购效率', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '灵活的议价方式', value: '提供多种形式的议价方式，例如竞价和议价，满足不同采购方案的需要', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '数据分析与决策支持', value: '通过数据分析和报告功能，提供对协议采购过程的全面分析和洞察，为决策提供支持', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据安全和隐私保护', value: '采用高级加密技术，保障协议采购数据的安全和隐私', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '高度透明和公正', value: '系统提供全程的信息共享和跟踪，确保协议采购过程的透明度和公正性，避免不公平行为', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '灵活配置和扩展性', value: '根据用户需求，提供灵活的配置和可定制开发，适应不同协议采购场景的需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'yhcgzc': {
    name: '优惠采购专场',
    color: '#25c251',
    icon: 'icon-youhuiquan',
    introduce: '提供一个集中展示优惠采购商品和促销活动的在线平台，为特定用户提供便捷、实惠的购物体验，推动优惠采购市场的发展',
    // 目标和目的
    targets: [
      { value: '提供一个集中展示优惠采购商品和促销活动的在线平台，为特定用户提供便捷、实惠的购物体验，推动优惠采购市场的发展' },
      { value: '为用户提供更多优质商品选择、帮助特定用户节省购物成本、增强用户购物满意度' },
    ],
    // 核心功能
    cores: [
      { title: '促销活动展示', value: '在线平台展示各类商家的优惠促销活动、打折销售和特价商品，让特定用户可以直观地了解各种优惠信息', icon: 'icon-iconfontzhizuobiaozhun0299' },
      { title: '商品分类与搜索', value: '支持商品按照分类进行浏览和搜索，帮助特定用户快速找到自己感兴趣的优惠商品', icon: 'icon-grouping' },
      { title: '商品详情展示', value: '提供商品详细描述、图片、评价等信息，让特定用户充分了解商品特性', icon: 'icon-chakan' },
      { title: '用户评价与分享', value: '用户可以对购买过的商品进行评价和分享，为其他用户提供参考意见', icon: 'icon-pingjia' },
      { title: '购物车和结算', value: '特定用户可以将心仪的商品加入购物车，并进行一次性结算，提供便捷的结账流程', icon: 'icon-gouwuche' },
      { title: '消息通知', value: '平台将及时向特定用户发送促销活动、优惠券等相关信息的消息通知', icon: 'icon-xiaoxitongzhi' },
    ],
    // 特色
    features: [
      { title: '丰富的供应商资源', value: '平台汇集了各类商家的优惠促销活动和商品，为特定用户提供丰富多样的选择', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '精准推荐与个性化服务', value: '通过用户浏览和购买行为的分析，为用户提供个性化的商品推荐和促销信息', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '实时更新与及时通知', value: '平台保持信息的实时更新，及时通知特定用户最新的促销活动和优惠商品', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '用户社区互动', value: '平台设有用户社区功能，用户可以互相分享购物经验、评价商品，增强用户之间的互动和交流', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '方便快捷的购物体验', value: '提供简单易用的界面和购物流程，让特定用户轻松享受网上优惠采购的便利', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '数据安全与隐私保护', value: '采用高级加密技术，保障用户的数据安全与隐私', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
    // 其他产品介绍...
  'zsjj': {
    name: '招商竞价',
    color: '#ffa500',
    icon: 'icon-zhaoshanghezuo',
    introduce: '招商竞价功能是一种旨在吸引外部投资者、合作伙伴或商家加入特定项目、平台或业务领域的综合性工具和策略集合。其核心目标是通过一系列的手段和措施，促进资源的整合与共享，实现互利共赢的合作关系，推动项目或业务的快速发展和壮大。',
    // 目标和目的
    targets: [
      { value: '筛选出具有较强实力、资源丰富且与项目定位匹配的投资者或商家,提升商场的整体品质和竞争力。' },
      { value: '确保项目资源,能够分配给最能发挥其价值的合作伙伴，提高资源的利用效率,实现更高的商业价值。' },
      { value: '通过公开、公平、公正的竞价机制，吸引更多潜在合作伙伴的关注，增强项目在市场上的吸引力和竞争力。' },
    ],
    // 核心功能
    cores: [
      // { title: '信息发布与展示', value: '全面、准确地发布招商项目的详细信息，包括项目概况、设备需求等，让潜在参与者充分了解情况。明确展示招商竞价的规则和流程，包括报名条件、竞价方式（如公开竞价、密封竞价等）、评标标准、时间安排等，确保参与者清楚知晓竞价要求', icon: 'icon-icon_111' },
      // { title: '报名与资格审核', value: '提供便捷的在线报名入口，允许潜在参与者提交报名信息，如企业基本信息、法定代表人信息、联系方式、投资意向等。对报名参与者的资格进行严格审核，根据预设的报名条件筛选出符合要求的参与者，并通知其审核结果', icon: 'icon-jingbiaoliebiao' },
      // { title: '竞价操作', value: '为参与者提供报价入口，允许其根据项目情况和自身需求提交报价和有关承诺。报价方式可以根据项目需求设置为单次报价、多次报价等。参与者和项目方都可以查询竞价过程中的报价记录，了解其他参与者的报价情况和竞价动态。例如，项目方可以实时查看各参与者的报价信息，分析市场反应和竞争态势', icon: 'icon-xiaoshouzidonghua' },
      // { title: '评标与定标', value: '根据预设的评标标准，对参与者的报价、资质、方案等进行综合评估。评标标准可以包括价格因素（如报价高低）和非价格因素（如企业实力、项目方案的可行性等）。确定中标者后，及时进行定标公示，公布中标结果和中标理由，确保竞价过程的公开、透明', icon: 'icon-hetongguanli' },
      // { title: '供应商管理', value: '管理供应商档案，包括供应商资质、信用记录、评价等信息，方便采购方与供应商建立长期的合作关系，支持多个供应商中标', icon: 'icon-gongyingshangguanli-' },
      { title: '信息发布', value: '详细发布招商项目的信息，包括项目概况和设备需求，确保参与者了解关键内容', icon: 'icon-icon_111' },
      { title: '信息展示', value: '清晰展示报名条件、竞价方式、评标标准和时间安排，让规则一目了然', icon: 'icon-jingbiaoliebiao' },
      { title: '报名入口', value: '提供在线报名入口，支持提交企业信息、联系方式及投资意向，方便参与者', icon: 'icon-xiaoshouzidonghua' },
      { title: '资格审核', value: '对报名企业进行严格审核，根据条件筛选符合要求的参与者，并通知审核结果', icon: 'icon-hetongguanli' },
      { title: '报价操作', value: '允许参与者根据项目需求进行单次或多次报价，支持实时查询竞价记录和动态', icon: 'icon-gongyingshangguanli-' },
      { title: '评标公示', value: '综合评估报价、资质等因素，完成评标后及时公示中标结果，确保透明和公平', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      // { title: '网络化操作', value: '通过网络平台实现在线招标、投标和合同签署，提高采购流程的效率和便捷性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      // { title: '高度透明', value: '系统提供全过程的信息共享和跟踪，确保采购过程的透明度，避免不公平行为的出现', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      // { title: '多维度竞价', value: '系统支持多种竞价方式，例如价格竞价、折扣率竞价等，满足不同采购需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      // { title: '数据安全和隐私保护', value: '采用高级加密技术，保障采购数据的安全和隐私', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      // { title: '数据分析与决策支持', value: '通过数据分析和报告功能，提供对采购过程的全面分析和决策支持，帮助采购方做出合理的决策', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: ' 公平公正', value: '招商竞价产品制定清晰、明确的竞价规则和评标标准，所有参与者都在相同的规则下进行竞争，确保公平性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '过程透明', value: '竞价过程全程公开透明，参与者可以实时查询报价记录和竞价动态，项目方也会对评标过程进行记录和公示，接受社会监督', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '高效便捷', value: '提供便捷的在线报名、报价、查询等功能，参与者无需到现场办理手续，节省时间和精力，提高招商效率', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '智能匹配', value: '利用大数据和人工智能技术，对参与者和项目进行智能匹配，为项目方推荐合适的合作伙伴，提高招商成功率', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '数据分析', value: '对招商竞价过程中的数据进行统计和分析，为项目方提供数据支持', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '个性化定制', value: '根据项目需求定制招商竞价方案，并提供专业招商咨询和项目对接等个性化服务', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
    ]
  },
  'fhsyhgl': {
    name: '发货收验货管理',
    color: '#f85835',
    icon: 'icon-31daifahuo',
    introduce: '帮助企业实现发货和采购用户收验货的高效管理，减少物流环节中的错误和延误，优化供应链管理流程',
    // 目标和目的
    targets: [
      { value: '帮助企业实现发货和采购用户收验货的高效管理，减少物流环节中的错误和延误，优化供应链管理流程' },
      { value: '提升发货和收货的准确性、降低物流成本、加强企业间的合作和信任' },
    ],
    // 核心功能
    cores: [
      { title: '订单管理', value: '系统自动创建和管理订单，供应商可以直接打印或下载货单含二维码等信息', icon: 'icon-dingdan' },
      { title: '货物追踪', value: '通过在线平台实时追踪货物的位置和状态，提供货物的实时可视化跟踪', icon: 'icon-wuliu' },
      { title: '发货指令', value: '采购用户可以向供应商发送发货指令，包括货物数量、配送要求等信息', icon: 'icon-fahuo-cebianlan' },
      { title: '收货确认', value: '接收方可以通过货单二维码在线确认收货，并进行验货和质量检查，及时提交反馈和问题', icon: 'icon-in-company' },
      { title: '异常处理', value: '支持处理货运过程中的异常情况，如延迟、损坏等，及时解决问题并提供相应处理措施', icon: 'icon-yichangchuliyemian' },
      { title: '数据分析与报告', value: '系统收集和分析发货和收货过程中的数据，生成统计报告和趋势分析，为用户提供数据支持', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '便捷高效的物流管理', value: '提供在线平台，使物流管理流程更加便捷高效，减少传统纸质和人工操作的繁琐', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '实时货物跟踪', value: '通过实时追踪货物的位置和状态，提供准确的货物跟踪和配送信息，增强对物流链的可视化管理', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '强化合作与信任', value: '通过在线平台，企业之间可以方便地进行订单管理、发货指令和收货确认，增强合作关系和信任度', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '数据分析与决策支持', value: '通过数据分析和报告功能，提供对发货和收货过程的全面分析和洞察，为决策提供支持', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '提升准确性和效率', value: '通过在线录入、编辑和查询订单等功能，减少操作错误，提升发货和收货的准确性和效率', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
    ]
  },
  'dzhtgl': {
    name: '电子合同管理',
    color: '#1476ff',
    icon: 'icon-hetonglvyuejihua',
    introduce: '提供一个安全、高效的在线平台，帮助采购用户与供应商实现电子合同的创建、签署、管理和存储，简化合同管理过程，提高合同管理效率和准确性',
    // 目标和目的
    targets: [
      { value: '提供一个安全、高效的在线平台，帮助采购用户与供应商实现电子合同的创建、签署、管理和存储，简化合同管理过程，提高合同管理效率和准确性' },
      { value: '降低合同管理的时间和成本、提高合同管理的可追溯性和便利性、增强合同执行的合规性' },
    ],
    // 核心功能
    cores: [
      { title: '合同创建和编辑', value: '用户可以在平台上在线创建和编辑合同，输入相关合同内容并进行格式化编辑', icon: 'icon-tousu' },
      { title: '签署流程管理', value: '通过在线平台设置电子签署流程，包括签署顺序和授权人员等信息，确保合同的正确签署和认证', icon: 'icon-liucheng' },
      { title: '签署验证与保护', value: '提供电子签名认证和合同完整性验证，确保签署的合同的真实性和完整性', icon: 'icon-hetongqianshu' },
      { title: '合同存储与管理', value: '合同存储在云端，提供便捷的合同搜索、分类和归档功能，方便用户对合同进行管理和查阅', icon: 'icon-hetongguanli' },
      { title: '通知和提醒', value: '平台会向相关人员发送通知和提醒，包括合同签署、合同到期等相关信息的提醒', icon: 'icon-xiaoxitongzhi' },
      { title: '数据分析与报告', value: '系统收集和分析合同管理过程中的数据，生成相关报告和统计分析，为用户提供决策支持', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '安全和保密性', value: '采用安全的加密技术和权限控制机制，确保合同内容的安全和保密性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '简化合同管理流程', value: '通过在线平台实现合同的创建、签署、管理和存储等环节的全流程在线化和自动化', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '实时追踪和提醒', value: '提供实时的合同进度追踪和签署提醒，帮助用户掌握合同的最新状态', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '多样化的合同模板', value: '提供多种常用的合同模板，使用户可以快速创建符合要求的合同', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '可靠便捷的电子签名认证', value: '支持可靠便捷的电子签名认证，确保签署合同的合法性和有效性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '数据分析和报告', value: '通过数据分析和报告功能，提供对合同管理过程的全面分析和洞察，为决策提供支持', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'ysgl': {
    name: '验收管理',
    color: '#25c251',
    icon: 'icon-xiangmuyanshou_yanshou',
    introduce: '提供一个全面、高效的在线平台，用于跟踪和管理项目或产品的验收过程，确保项目或产品按照规定的标准和要求完成，并满足用户的需求和期望',
    // 目标和目的
    targets: [
      { value: '提供一个全面、高效的在线平台，用于跟踪和管理项目或产品的验收过程，确保项目或产品按照规定的标准和要求完成，并满足用户的需求和期望' },
      { value: '提高项目或产品的质量和可靠性，减少问题和风险，增强用户满意度' },
    ],
    // 核心功能
    cores: [
      { title: '验收计划制定', value: '制定详细的验收计划，明确项目或产品的验收时间、验收标准和验收流程等内容', icon: 'icon-liucheng' },
      { title: '验收状态追踪', value: '实时跟踪项目或产品的验收进度和状态，了解当前的完成情况', icon: 'icon-jurassic_jiankong' },
      { title: '缺陷管理', value: '记录并管理在验收过程中发现的缺陷、问题和改进建议，确保及时解决和反馈', icon: 'icon-tz_app_guangzhiyewubaobiao' },
      { title: '验收文档管理', value: '存储和管理与项目或产品验收相关的文档，包括验收报告、测试文档等', icon: 'icon-wendangguanli-xiangmuleiwendang' },
      { title: '沟通与协作', value: '提供在线沟通和协作工具，方便项目团队和验收方之间的交流和合作', icon: 'icon-teamwork' },
      { title: '数据分析与报告', value: '收集和分析项目或产品验收过程中的数据，生成相关报告和统计分析，为决策提供支持', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '完整的验收流程', value: '提供完整的验收流程，涵盖计划制定、状态追踪、缺陷管理等环节，确保全面管理项目或产品的验收过程', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '高效的沟通和协作', value: '通过在线沟通和协作工具，方便团队成员之间的交流，提高协作效率', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '可定制化的验收标准', value: '支持用户根据自身需求定制验收标准和流程，并进行灵活调整和扩展', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '实时状态追踪和提醒', value: '提供实时的验收状态追踪和提醒，及时了解项目或产品的进展情况', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '数据分析和报告', value: '通过数据分析和报告功能，提供对验收过程的全面分析和洞察，为决策提供支持', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '安全性和权限控制', value: '采用安全的加密技术和权限控制机制，确保数据的安全性和合规性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'sjhcccgl': {
    name: '试剂耗材仓储管理',
    color: '#f85835',
    icon: 'icon-cangchu',
    introduce: '帮助实验室或科研机构管理试剂和耗材的库存、入库、出库以及采购等相关流程，优化仓储管理，降低成本，提高效率和溯源能力',
    // 目标和目的
    targets: [
      { value: '帮助实验室或科研机构管理试剂和耗材的库存、入库、出库以及采购等相关流程，优化仓储管理，降低成本，提高效率和溯源能力' },
      { value: '实现试剂和耗材的有效利用、保证科研工作的正常进行，并确保试剂和耗材的安全性和质量' },
    ],
    // 核心功能
    cores: [
      { title: '试剂、耗材入库管理', value: '记录和管理试剂、耗材的入库信息，包括批次、生产日期、有效期等，确保准确且及时入库', icon: 'icon-rukuguanli' },
      { title: '库存管理', value: '对试剂、耗材库存进行实时监控和管理，包括库存数量、存放位置、库存预警等', icon: 'icon-churukuguanli' },
      { title: '出库与领用', value: '根据用户需求，管理试剂、耗材的出库申请、审批和领用，确保合理使用和流程规范', icon: 'icon-chuku' },
      { title: '采购管理', value: '记录和管理试剂、耗材的采购需求、供应商信息、采购合同等，方便统一管理和跟踪采购流程', icon: 'icon-caigouguanli' },
      { title: '库存查询与调配', value: '提供库存查询功能，支持实时查询试剂、耗材库存信息，并根据需要进行调配', icon: 'icon-fq_kucunchaxun' },
      { title: '数据分析与报告', value: '收集和分析试剂、耗材仓储管理数据，生成相关报告和统计分析，为决策提供支持', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '标准化的管理流程', value: '提供标准化的试剂、耗材仓储管理流程，规范入库、出库、领用和采购等环节', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '精准的库存管理', value: '通过实时库存监控和预警功能，帮助用户及时了解库存情况，避免缺货或过多库存的问题', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '安全性与质量控制', value: '确保试剂、耗材的安全性和质量，跟踪记录批次、生产日期、有效期以及废弃物回收情况等信息，提供溯源能力', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '智能化的库存查询', value: '支持智能化库存查询，可以根据试剂、耗材名称、规格、存放位置等条件进行快速查询', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '数据分析与决策支持', value: '通过数据分析与报告功能，提供对仓储管理数据的分析和洞察，为决策提供支持', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '可定制化的系统设置', value: '支持用户根据实际需求进行系统的定制设置，适应不同实验室或科研机构的管理要求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'jzzfgl': {
    name: '集中支付管理',
    color: '#1476ff',
    icon: 'icon-zhifubaofukuan',
    introduce: '提供一个便捷、安全的在线平台，帮助采购用户实现对供应商采购费用通过第三方实施的集中支付和管理',
    // 目标和目的
    targets: [
      { value: '提供一个便捷、安全的在线平台，帮助采购用户实现对供应商采购费用通过第三方实施的集中支付和管理' },
      { value: '简化采购费用支付流程，提高支付效率和准确性，降低采购用户的财务风险，优化资金利用和管理' },
    ],
    // 核心功能
    cores: [
      { title: '采购费用管理', value: '记录和管理各类采购费用信息，包括采购金额、供应商信息、费用类别等，并实现数据可视化展示', icon: 'icon-feiyongguanli' },
      { title: '采购费用核算', value: '根据采购用户内部规定，实现采购费用的核算和分配，确保各项费用的准确计算和合理分摊', icon: 'icon-icon-money' },
      { title: '资金归集与结算', value: '集中管理采购用户各部门或项目的采购费用，并实现资金的统一归集和结算，降低采购用户的付款风险', icon: 'icon-ziyuan1' },
      { title: '银行账户管理', value: '集成银联支付系统，实现银行账户的关联和管理，为支付提供便利和安全保障', icon: 'icon-chuxuqiashezhi' },
      { title: '财务报表与分析', value: '支持生成采购费用支付相关的财务报表，方便财务分析和决策', icon: 'icon-caizhengxinxi' },
      { title: '数据安全与隐私保护', value: '采用安全的加密技术和权限控制机制，确保数据的安全性和隐私保护', icon: 'icon-ziyuan' },
    ],
    // 特色
    features: [
      { title: '银联支付集成', value: '与银行合作，通过银联支付系统实现采购费用的在线支付，方便快捷并且安全可靠', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '自动化流程', value: '通过自动化的流程和系统支持，简化采购费用支付流程，减少人工操作和错误', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '多级权限', value: '设置多种角色和权限级别，确保不同用户只能访问和操作自己需要的信息和功能，提高数据安全性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '实时数据更新', value: '实时更新采购费用相关数据，保证数据的准确性和及时性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '移动端支持', value: '提供移动端应用程序，方便采购用户及供应商在任何时间、任何地点进行采购费用管理、支付及查询', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '定制化报表', value: '支持根据采购用户需求定制化财务报表和分析，满足采购用户的特定需求', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'pbzjgl': {
    name: '评标专家管理',
    color: '#f85835',
    icon: 'icon-zhuanjia',
    introduce: '用于管理评标专家的信息、选拔、指派和绩效考核等过程',
    // 目标和目的
    targets: [
      { value: '用于管理评标专家的信息、选拔、指派和绩效考核等过程' },
      { value: '优化评标专家管理流程，提高评标质量和效率，保证评标结果的公正性和客观性，为项目评标提供专业的支持' },
    ],
    // 核心功能
    cores: [
      { title: '评标专家信息管理', value: '录入和管理评标专家的基本信息、资质证明以及专业领域等，并支持实时更新和查询', icon: 'icon-zhuanjia' },
      { title: '评标专家选拔', value: '根据项目要求和评标专家的专业背景，进行评标专家的选拔和筛选，并生成相关评审记录', icon: 'icon-xuanzhong' },
      { title: '评标专家指派', value: '根据项目需求，进行评标专家的指派和安排，并提供通知和会议安排功能', icon: 'icon-renyuansousuo11' },
      { title: '绩效考核与管理', value: '对评标专家进行绩效考核，记录评审结果和评价意见，提供个体和整体绩效分析报告', icon: 'icon-jixiaokaohe' },
      { title: '网上评标会议支持', value: '提供在线评标会议功能，包括会议日程安排、文件共享、投票等，方便评标专家的远程参与', icon: 'icon-yuncangchujichengpingtaiban' },
      { title: '数据分析与报告', value: '收集和分析评标专家管理数据，生成相关报告和统计分析，为决策提供支持', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '高效的管理流程', value: '通过在线平台，实现评标专家信息管理、选拔、指派和绩效考核等评标专家管理流程的高效化', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '灵活的专家指派', value: '支持根据项目需求进行评标专家的灵活指派和调整，确保评审团队的多样性和专业性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '安全保密性', value: '采用安全加密技术和权限控制机制，确保评标专家信息和评审过程的安全和保密性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '在线协作与共享', value: '提供在线协作和文件共享功能，方便评标专家之间的沟通和合作，提高评审效率', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
      { title: '数据分析与决策支持', value: '通过数据分析和报告功能，提供对评标专家管理数据的全面分析和洞察，为决策提供支持', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Video/video_pc1.svg' },
      { title: '移动端支持', value: '提供移动端应用程序，方便评标专家随时随地进行管理和参与评标工作', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Manage/setting_card.svg' },
    ]
  },
  'cgxqdc': {
    name: '采购需求调查',
    color: '#f85835',
    icon: 'icon-caigoudingdanhuiqian',
    introduce: '帮助高校或组织全面、深入地了解市场上与采购相关的各类信息，从而为采购决策提供有力支持',
    // 目标和目的
    targets: [
      { value: '了解市场供应情况，掌握市场价格水平' },
      { value: '优化采购决策，保障采购质量' },
    ],
    // 核心功能
    cores: [
      { title: '供应商信息收集', value: '全面收集供应商的基本信息、产品规格及服务内容，为采购决策提供基础数据支持', icon: 'icon-zhuanjia' },
      { title: '市场价格采集与整理', value: '实时采集并整理市场价格数据，构建价格数据库，为企业采购提供价格参考', icon: 'icon-xuanzhong' },
      { title: '供应能力分析', value: '评估供应商的生产能力、库存及交货期，分析市场供需趋势，支持采购需求匹配', icon: 'icon-renyuansousuo11' },
      { title: '价格趋势分析', value: '通过数据分析预测价格走势，并分析波动原因，为企业制定应对策略提供依据', icon: 'icon-jixiaokaohe' },
      { title: '调查总结报告生成', value: '基于市场调查数据生成包含供应情况、价格水平及供应商评估的直观可视化报告', icon: 'icon-yuncangchujichengpingtaiban' },
      { title: '决策建议报告生成', value: '结合市场分析为企业提供供应商选择、采购时机及价格谈判等具体决策建议', icon: 'icon-shujufenxi1' },
    ],
    // 特色
    features: [
      { title: '全面性与准确性', value: '广泛覆盖多行业、多地区的市场信息，并通过严格的数据验证机制确保数据的真实性和可靠性', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/quanqiuwendingjiasu.svg' },
      { title: '实时性与动态性', value: '实时更新市场数据，动态监测市场变化，并在供应、价格等出现重大波动时及时预警，助力企业调整采购策略', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Cloud/cloud-off.svg' },
      { title: '智能化与个性化', value: '运用人工智能和大数据技术深度分析数据，提供智能化报告和决策建议，同时支持根据企业需求定制个性化调查方案', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/product/CDN/jiandanyiyong.svg' },
      { title: '易用性与可视化', value: '通过简洁直观的操作界面和可视化展示方式（如图表、图形），使数据采集、分析和报告生成更易操作和理解', icon: 'https://res-static.hc-cdn.cn/cloudbu-site/public/Icon/Speed/speed-service.svg' },
    ]
  },
}

export { productServices, information_keys }



// WEBPACK FOOTER //
// ./src/constants/product.js